import { FooterPortal, NavbarPortal } from "components";
import loginImage from "../../assets/images/portal/login.webp";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { PulseLoader } from "react-spinners";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  API_URL_forgotPassword,
  API_URL_login,
  API_URL_resetPassword,
} from "constants/api";
// import { loginUser } from "redux/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { isAuth } from "actions";
import jwt_decode from "jwt-decode";
import { loginUser } from "actions/auth";

const ResetPassword = () => {
  const { token } = useParams();
  const { loginUserResult, loginUserLoading } = useSelector(
    (state) => state.auth
  );
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [visiblePasswordConfirm, setVisiblePasswordConfirm] = useState(false);
  const [message, setMessage] = useState("");
  const [formulir, setFormulir] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      password: "",
      passwordconfirm: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Password Required"),
      passwordconfirm: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Password Confirmation Required"),
    }),
    onSubmit: (values) => {
      axios({
        method: "POST",
        data: {
          password: values.password,
          passwordconfirm: values.passwordconfirm,
          token: token,
        },
        url: API_URL_resetPassword,
      })
        .then((response) => {
          toast.success(response.data.message, {
            position: "top-center",
            autoClose: true,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          formik.resetForm();
          setTimeout(() => {
            navigate("/auth-apjii/login");
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: true,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          formik.resetForm();
        });
    },
  });

  useEffect(() => {
    if (loginUserResult || isAuth()) {
      window.location.href = "/";
    }
  }, [loginUserResult]);

  useEffect(() => {
    // Dekode token JWT
    try {
      const decodedToken = jwt_decode(token);
      const currentTime = Date.now() / 1000; // Ubah ke detik (timestamp Unix)

      // Periksa apakah token sudah kadaluwarsa
      if (currentTime > decodedToken.exp) {
        setMessage(
          "Maaf Token sudah kadaluwarsa. Silakan klik forgot password kembali"
        );
        setFormulir(false);
      } else {
        setFormulir(true);
      }
    } catch (error) {
      // Token tidak valid, munculkan pesan kesalahan
      setMessage("Token tidak valid. Silakan klik forgot password kembali");
    }
  }, [token]);

  return (
    <>
      <div className="flex flex-col min-h-screen overflow-y-auto text-gray-700">
        <main className="flex flex-grow">
          <div className="w-full">
            <NavbarPortal current={"Beranda"} isGradient={true} />

            <div className="relative flex flex-row w-full justify-between">
              <div className="absolute md:static z-0 w-full md:w-1/2 h-full md:block">
                <img
                  src={loginImage}
                  className="h-[36em] gambar-login w-full"
                />
              </div>
              <div className="absolute md:static z-10 w-full md:w-1/2 bg-transparent h-fit ">
                <div className="px-5 py-5 lg:py-8 padding-topbottom lg:px-14">
                  <div className="border-2 shadow-2xl rounded-lg px-5 lg:py-8 py-5 lg:px-14 bg-white mt-10 md:mt-0 md:h-[32em]">
                    <p className="text-2xl md:text-5xl font-bold mb-4">
                      Reset Password
                    </p>
                    <p className=" md:text-xl mb-2 md:mb-10 text-gray-500">
                      Please insert a new password
                    </p>

                    {message && (
                      <div className="text-red-500 text-center mt-4">
                        {message}
                      </div>
                    )}

                    {formulir && (
                      <form onSubmit={formik.handleSubmit}>
                        <div className="relative mb-4">
                          <label className="font-bold">Password</label>
                          <input
                            id="password"
                            type={visiblePassword ? "text" : "password"}
                            name="password"
                            placeholder="Masukkan Password"
                            onChange={formik.handleChange}
                            value={formik.values.password}
                            className="w-full px-1 py-2 border-2 mt-1 border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                          />
                          <div
                            className="absolute text-gray-400 top-[36px] right-2 text-2xl cursor-pointer"
                            onClick={() => setVisiblePassword(!visiblePassword)}
                          >
                            {visiblePassword ? <FaEye /> : <FaEyeSlash />}
                          </div>
                          {formik.touched.password &&
                            formik.errors.password && (
                              <div className="text-red-500">
                                {formik.errors.password}
                              </div>
                            )}
                        </div>
                        <div className="relative mb-4">
                          <label className="font-bold">
                            Password Confirmation
                          </label>
                          <input
                            id="passwordconfirm"
                            type={visiblePasswordConfirm ? "text" : "password"}
                            name="passwordconfirm"
                            placeholder="Masukkan Password Konfirmasi"
                            onChange={formik.handleChange}
                            value={formik.values.passwordconfirm}
                            className="w-full px-1 py-2 border-2 mt-1 border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                          />
                          <div
                            className="absolute text-gray-400 top-[36px] right-2 text-2xl cursor-pointer"
                            onClick={() =>
                              setVisiblePasswordConfirm(!visiblePasswordConfirm)
                            }
                          >
                            {visiblePasswordConfirm ? (
                              <FaEye />
                            ) : (
                              <FaEyeSlash />
                            )}
                          </div>
                          {formik.touched.passwordconfirm &&
                            formik.errors.passwordconfirm && (
                              <div className="text-red-500">
                                {formik.errors.passwordconfirm}
                              </div>
                            )}
                        </div>

                        <button
                          type="submit"
                          disabled={loginUserLoading}
                          className="bg-gradient-to-b from-sky-600 to-sky-900 text-white w-full py-2 hover:bg-gradient-to-br text-xl"
                        >
                          {loginUserLoading ? (
                            <PulseLoader color="#fff" size={11} />
                          ) : (
                            "Send"
                          )}
                        </button>
                      </form>
                    )}
                    <div className="flex justify-between mt-4 text-blue-500 hover:text-blue-700">
                      <Link to={`/forgot-password`}>Forgot password</Link>
                      <Link to={`/auth-apjii/login`}>Login</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <FooterPortal />
      </div>
    </>
  );
};

export default ResetPassword;
